import { render, staticRenderFns } from "./AdminTestimonialsView.vue?vue&type=template&id=e69db7aa&scoped=true"
import script from "./AdminTestimonialsView.vue?vue&type=script&lang=js"
export * from "./AdminTestimonialsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69db7aa",
  null
  
)

export default component.exports